import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature23',
      playScale: 0.01,
      always: false,
    },
    itemWrapper: {
      className: 'feature23-img',
      children: [
        {
          name: 'left',
          className: 'feature23-img',
          children: 'https://imm.86links.com/assets/landing/feature/Waterfall-left.jpeg',
        },
        {
          name: 'right',
          className: 'feature23-img',
          children: 'https://imm.86links.com/assets/landing/feature/Waterfall-right.jpeg',
        },
      ],
    },
  },
};
